import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f4a0a37"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }

import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useIp, useInfo } from '@/store';
import { Autoplay } from 'swiper';
import Swiper from '../base/Swiper.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'Kv',
  setup(__props) {

_useCssVars(_ctx => ({
  "dec73c66": (_unref(mask).pc),
  "6466f2cc": (_unref(mask).mobile[0]),
  "6466f2eb": (_unref(mask).mobile[1])
}))

const { kv } = storeToRefs(useIp());
const { getImg } = useInfo();
const mask = computed(() => ({
  pc: `url(${getImg('ip_pc_around_mask')})`,
  mobile: [
    `url(${getImg('ip_mobile_around_mask')})`,
    `url(${getImg('ip_mobile_bottom_mask')})`,
  ],
}));

return (_ctx: any,_cache: any) => {
  return (_unref(kv).length > 0)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createVNode(Swiper, {
          list: _unref(kv),
          prefix: 'bg',
          module: _unref(Autoplay),
          loop: _unref(kv).length > 1,
          autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      }
        }, null, 8, ["list", "module", "loop"])
      ]))
    : _createCommentVNode("", true)
}
}

})